export default "__VITE_ASSET__KBWKSSiY__"